const applicationUrls = {
    fetchApplications: {
        url: '/application/'
    },
    fetchApplication: {
        url: '/application/:id'
    },
    fetchFormOptions: {
        url: '/application/actions/formOptions'
    },
    fetchCandidates: {
        url: '/application/:id/candidates'
    },
    removeCandidate: {
        url: '/application/:id/removeCandidate'
    },
    addCandidate: {
        url: '/application/:id/addCandidate'
    },
    generateToken: {
        url: '/application/:id/generateToken'
    },
    getPinservice: {
        url: '/integrator/pinservice'
    },
    photoByPin: {
        url: '/integrator/photo'
    },
    createEvent: {
        url: '/application/:id/createEvent'
    },
    fetchTestingEvents: {
        url: '/application/:id/testingEvents'
    },
    confirmApplication: {
        url: '/application/:id/confirm'
    },
    rejectApplication: {
        url: '/application/:id/reject'
    },
    rejectRetake: {
        url: '/application/:id/rejectRetake'
    },
    fetchSuitableStructures: {
        url: '/application/:id/suitableStructures'
    },
    setStructure: {
        url: '/application/:id/setStructure'
    },
    fetchAppResults: {
        url: '/application/:id/results'
    },
    downloadAppResults: {
        url: '/application/:id/downloadAppResult'
    },
    downloadResults: {
        url: '/application/:id/downloadResult'
    },
    fileUpload: {
        url: '/upload/'
    },
    fetchPositionData: {
        url: '/application/:id/position'
    },
    fetchStateResources: {
        url: '/application/actions/getStates'
    },
    fetchStatsOptions: {
        url: '/application/actions/statsOptions'
    },
    notifyCandidates: {
        url: '/application/:id/notifyCandidates'
    },
    generateTokenList: {
        url: '/application/:id/generateTokenList'
    },
    downloadRegistrationList: {
        url: '/application/:id/registrationList'
    },
    getAppLogins: {
        url: '/application/:id/logins'
    },
    stateFormOptions: {
        url: '/application/actions/stateFormOptions'
    },
    publish: {
        url: '/application/:id/publish'
    },

};
export default applicationUrls;
